import { SurveyCreator } from 'survey-creator-react';
import { JsonObject } from 'survey-core';
import CustomWidget from 'vl-md/src/CustomSurvey/customWidgets/CustomWidget';

/** Renders a custom Virtual Lucy Banner for the survey. */
const CustomizeSurveyBanner = (surveyCreator?: SurveyCreator, name = 'banner') => {
  const afterRenderHandler = (question, el) => {
    const onValueChangedCallback = () => {
      const image = el.getElementsByTagName('img')[0];
      image.src =
        question.Image ||
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAIAAACRXR/mAAAAO0lEQVRYw+3OMQEAAAgDILV/55nA3wMS0Enqn6mXtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tC4LASgDYYQvFyUAAAAASUVORK5CYII=';
      image.height = question.Height;
      image.alt = question.name;
      const container = el.getElementsByClassName('sv-banner')[0];
      const overlay = container.getElementsByTagName('div')[0];
      overlay.className = `sv-banner-text-${question.Position.toLowerCase()} sv-banner-text-${question.TextColour.toLowerCase()}`;
      const heading = el.getElementsByTagName('h1')[0];
      heading.innerText = question.Heading;
      const subheading = el.getElementsByTagName('h3')[0];
      subheading.innerText = question.Subheading;
      const bannerButton = el.getElementsByTagName('button')[0];
      bannerButton.innerText = question.Button;
      bannerButton.onclick = function onClick() {
        window.open(question.Link, '_blank');
      };
      bannerButton.style = question.Button ? '' : 'display: none;';
    };
    const onReadOnlyChangedCallback = () => {
      const button = el.getElementsByTagName('button')[0];
      if (question.isReadOnly) {
        button.setAttribute('disabled', 'disabled');
      } else {
        button.removeAttribute('disabled');
      }
    };
    question.readOnlyChangedCallback = onReadOnlyChangedCallback;
    question.onPropertyValueChanged = onValueChangedCallback;
    onReadOnlyChangedCallback();
    onValueChangedCallback();
  };

  const activatedByChangeHandler = () => {
    JsonObject.metaData.addClass(name, [], null, 'empty');
    JsonObject.metaData.removeProperty(name, 'contentMode');
    JsonObject.metaData.addProperties(name, [
      {
        name: 'Height',
        type: 'minmaxnumber',
        choices: [50, 500],
        default: 200,
        category: 'Banner',
        visibleIndex: 3
      },
      {
        name: 'Image',
        type: 'link',
        category: 'Banner',
        visibleIndex: 4
      },
      {
        name: 'Position',
        choices: ['Center', 'Left', 'Right'],
        default: 'Center',
        category: 'Banner',
        visibleIndex: 5
      },
      {
        name: 'TextColour',
        choices: ['Black', 'White', 'Primary'],
        default: 'Black',
        category: 'Banner',
        visibleIndex: 6
      },
      {
        name: 'Heading',
        default: 'Example heading',
        category: 'Banner',
        visibleIndex: 7
      },
      {
        name: 'Subheading',
        default: 'More detail...',
        category: 'Banner',
        visibleIndex: 8
      },
      {
        name: 'Button',
        default: 'View',
        category: 'Banner',
        visibleIndex: 9
      },
      {
        name: 'Link',
        type: 'link',
        default: 'https://www.google.com',
        category: 'Banner',
        visibleIndex: 10
      }
    ]);
  };

  const title = 'Banner';
  const iconName = 'hbs-banner-class';
  const htmlTemplate =
    '<div data-testid="customized-banner-component"><div class="sv-banner"><img class="sv-banner-image"><div class="sv-banner-text-center"><h1></h1><h3></h3><button class="sv-btn"></button></div></div>';

  CustomWidget({
    name,
    title,
    iconName,
    activatedByChangeHandler,
    htmlTemplate,
    afterRenderHandler,
    surveyCreator
  });
};

export default CustomizeSurveyBanner;
